import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Router, RoutesRecognized} from '@angular/router';
import {filter, pairwise} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouterStateServiceService {
  previousUrl$ = new BehaviorSubject<string>(null);
  currentUrl$ = new BehaviorSubject<string>(null);
  constructor( private router: Router) {}
  init() {
    this.router.events
        .pipe(
            filter(evt => evt instanceof RoutesRecognized),
            pairwise()
        )
        .subscribe(
            ([previous, current]: [RoutesRecognized, RoutesRecognized]) => {
              this.previousUrl$.next(previous.urlAfterRedirects);
              this.currentUrl$.next(current.urlAfterRedirects);
            }
        );
  }
}
